import { forwardRef, useEffect, useImperativeHandle, useMemo } from 'react'
import { Menu, MenuItem } from '../menu/menu'
import { Card } from '../card/card'
import { SizeDisplay } from '../legacy/size-display'
import { IconDownload } from '../icon/icon'
import { useDownloadPresign } from '../download/hook'

export const StorageFileDetails = forwardRef(({ useApiFormFile, id }, ref) => {
  useImperativeHandle(ref, () => {
    return {
      reload: () => {
        apiFormFile.get(`${id}/details`)
      }
    }
  })

  const apiFormFile = useApiFormFile()
  const apiFormFileDownload = useApiFormFile()

  useEffect(
    () => {
      if (id) {
        apiFormFile.get(`${id}/details-if-exists`)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id]
  )

  const fileExists = useMemo(() => !!apiFormFile.form.key, [apiFormFile.form])

  const { active, download } = useDownloadPresign()

  const handleDownload = async () => {
    let presigned = await apiFormFileDownload.get(`${id}/presigned-download`)
    download(presigned.url)
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuItem Icon={IconDownload} text="download" disabled={active} onClick={handleDownload} show />
    </Menu>

  return (
    <Card title="Current Storage Details" HeaderMenu={HeaderMenu}>
      {fileExists
        ? <table>
            <tbody>
              <tr>
                <td>key</td>
                <td>
                  {apiFormFile.form.key}
                </td>
              </tr>
              <tr>
                <td>size</td>
                <td>
                  <SizeDisplay size={apiFormFile.form.contentLength} />
                </td>
              </tr>
              <tr>
                <td>lastModified</td>
                <td>
                  {apiFormFile.form.lastModified}
                </td>
              </tr>
            </tbody>
          </table>
        : <div className="p-2">File Not Found</div>}
    </Card>
  )
})
